// src/components/ArticleBlockRenderer.jsx
import React from "react";
import ArticleMarkdown from "./ArticleMarkdown";
import ArticleMedia from "./ArticleMedia";
import ArticleQuote from "./ArticleQuote";
import ArticleCta from "./ArticleCta";
import "./article.css";
import ArticleTable from "./ArticleTable";

const ArticleBlockRenderer = ({ block }) => {
  if (!block || !block.__component) {
    return null;
  }

  // Determine which component to render based on the Strapi __component field
  switch (block.__component) {
    case "shared.rich-text":
      return <ArticleMarkdown markdown={block.body} />;
    case "shared.media":
      return <ArticleMedia media={block.file || block.media} />;
    case "shared.quote":
      return <ArticleQuote quote={block.body} />;
    case "shared.cta":
      return <ArticleCta cta={block} />;
    case "shared.table":
      return <ArticleTable table={block} />;
    case "shared.editor": {
      // Normalize editor payloads: prefer string fields, then html property, then fallback to body
      const md =
        (typeof block.Editor === "string" && block.Editor) ||
        (block.Editor && typeof block.Editor.html === "string" && block.Editor.html) ||
        (typeof block.editor === "string" && block.editor) ||
        (block.editor && typeof block.editor.html === "string" && block.editor.html) ||
        (typeof block.body === "string" && block.body) ||
        "";

      return <ArticleMarkdown markdown={md} />;
    }
    // case 'article.slider':
    //   return <ArticleSlider images={block.images} />;
    default:
      console.warn(`Unknown block type: ${block.__component}`);
      return null;
  }
};

export default ArticleBlockRenderer;
